import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';
import { AdminHeader } from '../admin-header/admin-header';

@Component({
  selector: 'app-store-info',
  standalone: true,
  imports: [CommonModule, FormsModule, HttpClientModule, AdminSidebar, AdminHeader],
  templateUrl: './store-info.html',
  styleUrl: './store-info.css'
})
export class StoreInfo implements OnInit {
  stores: any[] = [];
  selectedStoreId: number | null = null;
  reportData: any[] = [];
  allReportData: any[] = [];
  loading = false;
  drugFilter: string = '';

  private baseUrl = 'https://logs.proofile.com.ng/api/store-report';

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.fetchStores();
  }

  fetchStores() {
    this.http.get<any[]>(`${this.baseUrl}/stores`).subscribe({
      next: (data) => this.stores = data,
      error: (err) => console.error('Failed to load stores:', err)
    });
  }

  loadReport() {
    if (!this.selectedStoreId) return;

    this.loading = true;
    this.http.get<any[]>(`${this.baseUrl}/report/${this.selectedStoreId}`).subscribe({
      next: (data) => {
        this.allReportData = data;
        this.reportData = [...data];
        this.drugFilter = '';
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load report:', err);
        this.loading = false;
      }
    });
  }

  applyDrugFilter() {
    const term = this.drugFilter.toLowerCase().trim();
    this.reportData = this.allReportData.filter(entry =>
      entry.drug.name.toLowerCase().includes(term)
    );
  }

  // ✅ This fixes the error you're seeing:
  resetDrugFilter() {
    this.drugFilter = '';
    this.reportData = [...this.allReportData];
  }
}
